import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        <div className="container">
            <div className="intro__content">
              <h1>
                Join our Team
              </h1>
              <p>
                Our goal is to have a profound impact on the future of youth sports. If you’re up for the challenge, join our lobby. 
              </p>
            </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroCareers.js